import {
    GETPROVIDERNAME_SUCCESS,
    GETPROVIDERNAME_FAILED,
    RESET_GETPROVIDERNAME,
    LOADING_GETPROVIDERNAME,
    NETWORK_ERROR_GETPROVIDERNAME
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETPROVIDERNAME:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETPROVIDERNAME_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETPROVIDERNAME_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETPROVIDERNAME:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETPROVIDERNAME:
            return (state = initialState);
        default:
            return state;
    }
};